import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { captureStencilRouteContent, resolveStencilRouteContentRoot } from './stencil-route-content.adapter';
import { observeStencilRouteContent } from './stencil-route-content.observer';
import { markStencilContentPending, markStencilContentReady } from './stencil-render-scheduler';
import { STENCIL_ROUTE_DEFAULT_CONTENT_SELECTOR } from './stencil-route-content.constants';
import type { StencilRouteContentSnapshot } from './stencil-route-content.model';
import { subscribeToStencilRouteTransitionStart } from './stencil-route-transition.store';

export const useStencilRouteTransitionListener = (contentSelector = STENCIL_ROUTE_DEFAULT_CONTENT_SELECTOR): void => {
    const location = useLocation();
    const transitionStartSnapshot = useRef<StencilRouteContentSnapshot | undefined>(undefined);

    useEffect(
        () =>
            subscribeToStencilRouteTransitionStart(() => {
                transitionStartSnapshot.current = captureStencilRouteContent(
                    resolveStencilRouteContentRoot(contentSelector)
                );
            }),
        [contentSelector]
    );

    useEffect(
        () =>
            observeStencilRouteContent({
                contentRoot: resolveStencilRouteContentRoot(contentSelector),
                startSnapshot: transitionStartSnapshot.current,
                onPending: markStencilContentPending,
                onReady: markStencilContentReady,
            }),
        [contentSelector, location.key]
    );
};
